import { PARTNER_API_LIST } from '../actions';

export const partnerApiList = (state = {}, action) => {
    const { type, payload } = action;
    if (type === PARTNER_API_LIST) {
      return payload;
    } else {
      return state;
    }
};